/**
 * Organization Dashboard Page
 * Entry point after onboarding is complete (hasFacility, hasFacilityStandards, hasLocation, hasLocationStandards).
 */

import React from 'react';
import MainPageLayout from '../../components/common/MainPageLayout';

export function DashboardPage() {
  return (
    <MainPageLayout customHeaderProps={{ hideBackButton: true }}>
      <div className="flex items-center justify-center min-h-[calc(100vh-200px)] py-8">
        <p className="text-lg text-gray-700">Organization dashboard page</p>
      </div>
    </MainPageLayout>
  );
}

export default DashboardPage;
